import React from "react";
import withRouter from "hoc/withRouter";
import { useGetAIFunctionsDetails } from "hooks/useGetAIFunctionsDetails";
import { Controller, useForm, FormProvider } from "react-hook-form";
import { TextField, Button, Card, CardContent, CardHeader, Typography } from "@mui/material";
import agentsService from "services/admin/AgentsService";
import _ from "lodash";
import { useEffect, useState } from "react";
import { AIFunctionPropertiesForm } from "../components/AIFunctionPropertiesForm/AIFunctionPropertiesForm";
import { toast } from "react-toastify";

const AgentFunctionForm = ({
  router: {
    params: { id: agentID, functionID },
  },
}: any) => {
  const { data, isLoading, error } = useGetAIFunctionsDetails(Number(agentID), Number(functionID));
  const [isSubmitting, setIsSubmitting] = useState(false);

  const methods = useForm({
    defaultValues: {
      name: _.get(data, "name", "get_tourpackages"),
      description: _.get(data, "description", "Получение турапакетов по параметрам"),
      parameters: _.get(data, "parameters", [
        {
          name: "name",
          description: "Название функции",
          type: "string",
          required: true,
        },
      ]),
      status: _.get(data, "status", "active"),
    },
    mode: "onChange",
  });

  useEffect(() => {
    methods.reset({
      name: _.get(data, "name", "get_tourpackages"),
      description: _.get(data, "description", "Получение турапакетов по параметрам"),
      status: _.get(data, "status", "active"),
      parameters: _.get(data, "parameters", [
        {
          name: "name",
          description: "Название функции",
          type: "string",
          required: true,
        },
      ]),
    });
  }, [data]);

  const onSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      if (functionID) {
        await agentsService.updateAIFunction(Number(agentID), Number(functionID), data);
      } else {
        await agentsService.createAIFunction(Number(agentID), data);
      }
      toast.success("Функция сохранена успешно!");
    } catch (error) {
      console.error(error);
      toast.error("Ошибка при сохранении функции!");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Card className="mb-8">
            <CardHeader title={functionID ? "Редактирование функции" : "Создание функции"} />
            <CardContent>
              <div className="mb-4">
                <TextField
                  label="Название функции"
                  {...methods.register("name", { required: true })}
                  fullWidth
                />
              </div>
              <div className="mb-4">
                <TextField
                  label="Описание функции"
                  {...methods.register("description")}
                  fullWidth
                />
              </div>
              <div className="mb-4">
                <TextField label="Статус функции" {...methods.register("status")} fullWidth />
              </div>
            </CardContent>
          </Card>
          <Card className="mb-8">
            <CardHeader title="Параметры функции" />
            <CardContent>
              <div className="mb-4">
                <AIFunctionPropertiesForm />
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader title="Куда отправлять результат" />
            <CardContent>
              
            </CardContent>
          </Card>
          <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
            {isSubmitting ? "Сохранение..." : "Сохранить"}
          </Button>
          <pre>{JSON.stringify(methods.watch(), null, 2)}</pre>
        </form>
      </FormProvider>
    </div>
  );
};

export default withRouter(AgentFunctionForm);
